import { render, staticRenderFns } from "./IBack.vue?vue&type=template&id=19abc35e&"
import script from "./IBack.vue?vue&type=script&lang=ts&"
export * from "./IBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports